"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PINPopUp = void 0;
var React = __importStar(require("react"));
var PropTypes = __importStar(require("prop-types"));
var simples_1 = require("../simples");
var react_1 = require("@iconify/react");
var utilities_1 = require("../../utilities");
var PINPopUp = /** @class */ (function (_super) {
    __extends(PINPopUp, _super);
    function PINPopUp() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            noAnim: true
        };
        // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'event' implicitly has an 'any' type.
        _this.handleDocumentClick = function (event) {
            if (!_this.contentNode
                || _this.contentNode.contains(event.target)
                || (event.keyCode && event.keyCode !== 27)) {
                return;
            }
            _this.props.closeAction(event);
        };
        return _this;
    }
    // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'nextProps' implicitly has an 'any' type... Remove this comment to see the full error message
    PINPopUp.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.state.noAnim && nextProps.isOpen !== this.props.isOpen) {
            this.setState(function () { return ({ noAnim: false }); });
        }
        if (nextProps.isOpen) {
            document.addEventListener("click", this.handleDocumentClick, false);
            document.addEventListener("keydown", this.handleDocumentClick, false);
        }
        else {
            document.removeEventListener("click", this.handleDocumentClick, false);
            document.removeEventListener("keydown", this.handleDocumentClick, false);
        }
    };
    PINPopUp.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { className: "pinpopup " + (this.props.isOpen ? "opened" : "closed") + (this.state.noAnim ? " noanim" : "") },
            React.createElement("div", { className: "pinpopup-wrapper " + this.props.wrapperClass },
                React.createElement("div", { className: "pinpopup-row " + this.props.rowClass },
                    React.createElement("div", { className: "pinpopup-content " + this.props.contentClass, ref: function (node) { _this.contentNode = node; } },
                        React.createElement(simples_1.PINButton, { inline: true, className: "pinpopup-close-button", onClick: this.props.closeAction },
                            React.createElement(react_1.Icon, { className: "close-icon", icon: "mdi:close", style: { fontSize: "1.2rem" }, color: utilities_1.Colors.nightBlack })),
                        this.props.children)))));
    };
    PINPopUp.propTypes = {
        isOpen: PropTypes.bool,
        closeAction: PropTypes.func.isRequired,
        wrapperClass: PropTypes.string,
        rowClass: PropTypes.string,
        contentClass: PropTypes.string
    };
    return PINPopUp;
}(React.Component));
exports.PINPopUp = PINPopUp;
//# sourceMappingURL=PINPopUp.js.map